import { render, staticRenderFns } from "./FormReason.vue?vue&type=template&id=25162a4f"
import script from "./FormReason.vue?vue&type=script&lang=js"
export * from "./FormReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormReason.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25162a4f')) {
      api.createRecord('25162a4f', component.options)
    } else {
      api.reload('25162a4f', component.options)
    }
    module.hot.accept("./FormReason.vue?vue&type=template&id=25162a4f", function () {
      api.rerender('25162a4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/components/FormReason.vue"
export default component.exports